import { Pagination } from '@/constants/pagination';
import type { CursorPaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type WalletsState = {
  dataWalletsSummary?: WalletsSummaryType;
  dataWallets: WalletItem[];
  pagination: CursorPaginationAPI;
};

export const walletsInitialState: WalletsState = {
  pagination: {
    nextCursor: null,
    previousCursor: null,
    hasMore: false,
    hasPrevious: false,
    pageSize: Pagination.Size,
  },
  dataWallets: [],
};

export const slice = createSlice({
  name: 'wallets',
  initialState: walletsInitialState,
  reducers: {
    setWalletsSummaryAction(
      state,
      { payload }: PayloadAction<{ dataWalletsSummary: WalletsSummaryType }>,
    ) {
      state.dataWalletsSummary = payload.dataWalletsSummary;
    },
    setListWalletsAction(
      state,
      {
        payload,
      }: PayloadAction<{
        dataWallets: WalletItem[];
        append?: boolean;
        pagination?: CursorPaginationAPI;
      }>,
    ) {
      if (payload.append) {
        const existingWalletIds = new Set(state.dataWallets.map((wallet) => wallet.id));
        state.dataWallets.push(
          ...payload.dataWallets.filter((wallet) => !existingWalletIds.has(wallet.id)),
        );
      } else {
        state.dataWallets = payload.dataWallets;
      }
      state.pagination = payload.pagination ?? state.pagination;
    },
  },
});

export const { setWalletsSummaryAction, setListWalletsAction } = slice.actions;

export default slice.reducer;
